import { deserializeResponse } from '@apeiron/temp'
import { useMutation } from '@apollo/client'
import graphql from '@src/graphql/mutation/saveInviteSetting'
import { useCallback, useState } from 'react'

const useUpdateOrbitalTrackInviteSettings = (): Hook => {
  const [update, { loading }] = useMutation(graphql)

  const [data, setData] = useState<Response>(false)

  const mutate = useCallback(
    async (param: RequestParam): Promise<Response> => {
      const response = await update({
        variables: param
      })

      const result = deserializeResponse(response) as boolean

      setData(result)

      return result
    },
    [update]
  )

  return {
    mutate,
    data,
    loading
  }
}

export type UpdateOrbitalTrackInviteSettingsInput = {
  groupName?: string
  inviteGroupID: string
  priority?: number
}

type RequestParam = {
  starID: string
  settings: UpdateOrbitalTrackInviteSettingsInput[]
}

type Response = boolean

type Hook = {
  mutate: (param: RequestParam) => Promise<Response>
  data: Response
  loading: boolean
}

export default useUpdateOrbitalTrackInviteSettings
